module.exports = __webpack_public_path__ + "mo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mo.svg
// module id = 697
// module chunks = 0